import { generateFloatingToolbarActions, editorConfig } from './../config';
import { useMemo } from 'react';

export const useGetAllToolbarOptions = () => {
  const allToolbarActions = useMemo(
    () => generateFloatingToolbarActions('', editorConfig?.features),
    [JSON.stringify(editorConfig?.features)]
  );

  return allToolbarActions;
};

export default useGetAllToolbarOptions;
